"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequestBuilder = void 0;
var PaymentRequestBuilder = /** @class */ (function () {
    function PaymentRequestBuilder() {
    }
    PaymentRequestBuilder.prototype.setOrder = function (order) {
        this.order = order;
        return this;
    };
    PaymentRequestBuilder.prototype.setPaymentMethods = function (paymentMethods) {
        this.paymentMethods = paymentMethods;
        return this;
    };
    PaymentRequestBuilder.prototype.setMetadata = function (metadata) {
        this.metadata = metadata;
        return this;
    };
    PaymentRequestBuilder.prototype.setClientConfig = function (clientConfig) {
        this.clientConfig = clientConfig;
        return this;
    };
    PaymentRequestBuilder.prototype.setOptions = function (options) {
        this.options = options;
        return this;
    };
    PaymentRequestBuilder.prototype.build = function () {
        return {
            order: this.order,
            paymentWith: this.paymentMethods,
            metadata: this.metadata,
            clientConfig: this.clientConfig,
            options: this.options,
        };
    };
    return PaymentRequestBuilder;
}());
exports.PaymentRequestBuilder = PaymentRequestBuilder;
